var map = {
	"./kaizerChiefs/basketball-category-icon-red.png": "bdb1",
	"./kaizerChiefs/basketball-category-icon-white.png": "a92f",
	"./kaizerChiefs/basketball-icon-red.png": "90c2",
	"./kaizerChiefs/basketball-icon-white.png": "e385",
	"./kaizerChiefs/cricket-category-icon-red.png": "ffeb",
	"./kaizerChiefs/cricket-category-icon-white.png": "860d",
	"./kaizerChiefs/cricket-icon-red.png": "49be",
	"./kaizerChiefs/cricket-icon-white.png": "2f52",
	"./kaizerChiefs/down-arrow-white copy.png": "134e",
	"./kaizerChiefs/football-category-icon-red.png": "eb79",
	"./kaizerChiefs/football-category-icon-white.png": "6a7b",
	"./kaizerChiefs/football-icon-red.png": "8fae",
	"./kaizerChiefs/football-icon-white.png": "16b4",
	"./kaizerChiefs/home-manager-icon-red.png": "93bf",
	"./kaizerChiefs/home-manager-icon-white.png": "4d15",
	"./kaizerChiefs/home-predict-icon-red.png": "f4e2",
	"./kaizerChiefs/home-predict-icon-white.png": "253d",
	"./kaizerChiefs/home-rugby-icon-red.png": "896c",
	"./kaizerChiefs/home-rugby-icon-white.png": "9472",
	"./kaizerChiefs/home-soccer-icon-red.png": "8be7",
	"./kaizerChiefs/home-soccer-icon-white.png": "bcc6",
	"./kaizerChiefs/logo-400x400.png": "2294",
	"./kaizerChiefs/menu-badge-icon-red.png": "da12",
	"./kaizerChiefs/menu-badge-icon-white.png": "ee7b",
	"./kaizerChiefs/menu-home-icon-red.png": "fb2e",
	"./kaizerChiefs/menu-home-icon-white.png": "893a",
	"./kaizerChiefs/menu-lock-icon-red.png": "adbd",
	"./kaizerChiefs/menu-lock-icon-white.png": "5e75",
	"./kaizerChiefs/menu-predict-icon-red.png": "5f15",
	"./kaizerChiefs/menu-predict-icon-white.png": "8ead",
	"./kaizerChiefs/menu-question-mark-icon-red.png": "4767",
	"./kaizerChiefs/menu-question-mark-icon-white.png": "daac",
	"./kaizerChiefs/menu-tandcs-icon-red.png": "9d94",
	"./kaizerChiefs/menu-tandcs-icon-white.png": "8cff",
	"./kaizerChiefs/menu-trophy-icon-red.png": "e70c",
	"./kaizerChiefs/menu-trophy-icon-white.png": "dad2",
	"./kaizerChiefs/minus-icon-grey.png": "379e",
	"./kaizerChiefs/minus-icon-red.png": "4bc6",
	"./kaizerChiefs/minus-icon-white.png": "2b18",
	"./kaizerChiefs/olympics-icon-white.png": "1e04",
	"./kaizerChiefs/plus-icon-white.png": "50d0",
	"./kaizerChiefs/pluss-icon-red.png": "eb31",
	"./kaizerChiefs/right-arrow-red.png": "80ae",
	"./kaizerChiefs/right-arrow-white.png": "83de",
	"./kaizerChiefs/right-down-red.png": "9215",
	"./kaizerChiefs/rugby-category-icon-red.png": "c1f6",
	"./kaizerChiefs/rugby-category-icon-white.png": "37a3",
	"./kaizerChiefs/rugby-icon-white.png": "c59d",
	"./kaizerChiefs/soccer-background-desktop.png": "d75d",
	"./kaizerChiefs/soccer-background-mobile.png": "b64b",
	"./kaizerChiefs/vodacom-basketball-background-desktop.png": "b311",
	"./kaizerChiefs/vodacom-basketball-background-mobile.png": "eac8",
	"./kaizerChiefs/vodacom-cricket-background-desktop.png": "3747",
	"./kaizerChiefs/vodacom-cricket-background-mobile.png": "b686",
	"./kaizerChiefs/vodacom-generic-background-desktop.png": "73be",
	"./kaizerChiefs/vodacom-generic-background-mobile.png": "efea",
	"./kaizerChiefs/vodacom-rugby-background-desktop.png": "133b",
	"./kaizerChiefs/vodacom-rugby-background-mobile.png": "0d15",
	"./leagues/Bundasliga.png": "5816",
	"./leagues/Japan-2021.png": "4fac",
	"./leagues/Ligue-1.png": "dcd3",
	"./leagues/Seriea.png": "806b",
	"./leagues/chlg.png": "03ae",
	"./leagues/cricket-t20-wc.png": "2b95",
	"./leagues/epl.png": "5165",
	"./leagues/euro-2020.png": "50cf",
	"./leagues/m.png": "f587",
	"./leagues/safr.png": "7aa7",
	"./leagues/spanishLaLiga.png": "cca2",
	"./olympics/disciplines/3x3-Basketball.png": "56b8",
	"./olympics/disciplines/Archery.png": "c3d0",
	"./olympics/disciplines/Artistic-Gymnastics.png": "23b6",
	"./olympics/disciplines/Artistic-Swimming.png": "c42f",
	"./olympics/disciplines/Athletics.png": "2049",
	"./olympics/disciplines/Badminton.png": "4cbc",
	"./olympics/disciplines/Baseball.png": "1c83",
	"./olympics/disciplines/Basketball.png": "96fb",
	"./olympics/disciplines/Beach-Volleyball.png": "804a",
	"./olympics/disciplines/Boxing.png": "0315",
	"./olympics/disciplines/Canoe-Slalom.png": "9548",
	"./olympics/disciplines/Canoe-Sprint.png": "4625",
	"./olympics/disciplines/Cycling-BMX-Freestyle.png": "e136",
	"./olympics/disciplines/Cycling-BMX-Racing.png": "bcd0",
	"./olympics/disciplines/Cycling-Mountain-Bike.png": "32a4",
	"./olympics/disciplines/Cycling-Road.png": "2261",
	"./olympics/disciplines/Cycling-Track.png": "f2e8",
	"./olympics/disciplines/Cycling.png": "1253",
	"./olympics/disciplines/Diving.png": "9b15",
	"./olympics/disciplines/Equestrian.png": "cab8",
	"./olympics/disciplines/Fencing.png": "12a1",
	"./olympics/disciplines/Football.png": "537b",
	"./olympics/disciplines/Golf.png": "2ad4",
	"./olympics/disciplines/Handball.png": "0e5f",
	"./olympics/disciplines/Hockey.png": "208c",
	"./olympics/disciplines/Judo.png": "2019",
	"./olympics/disciplines/Karate.png": "2a09",
	"./olympics/disciplines/Marathon-Swimming.png": "7980",
	"./olympics/disciplines/Modern-Pentathlon.png": "1808",
	"./olympics/disciplines/Rhythmic-Gymnastics.png": "e449",
	"./olympics/disciplines/Rowing.png": "501f",
	"./olympics/disciplines/Rugby-Sevens.png": "5a52",
	"./olympics/disciplines/Sailing.png": "4daa",
	"./olympics/disciplines/Shooting.png": "1f65",
	"./olympics/disciplines/Skateboarding.png": "c74b",
	"./olympics/disciplines/Sport-Climbing.png": "7670",
	"./olympics/disciplines/Surfing.png": "0658",
	"./olympics/disciplines/Swimming.png": "3770",
	"./olympics/disciplines/Table-Tennis.png": "2fe2",
	"./olympics/disciplines/Taekwondo.png": "0a1f",
	"./olympics/disciplines/Tennis.png": "ec3d",
	"./olympics/disciplines/Trampoline-Gymnastics.png": "bec9",
	"./olympics/disciplines/Triathlon.png": "1fb3",
	"./olympics/disciplines/Volleyball.png": "7624",
	"./olympics/disciplines/Water-Polo.png": "36b3",
	"./olympics/disciplines/Weightlifting.png": "b313",
	"./olympics/disciplines/Wrestling.png": "c2df",
	"./olympics/icons/Bronze-Square.png": "439b",
	"./olympics/icons/Bronze.png": "265a",
	"./olympics/icons/Gold-Square.png": "2b8c",
	"./olympics/icons/Gold.png": "0e51",
	"./olympics/icons/Silver-Square.png": "d92c",
	"./olympics/icons/Silver.png": "a11e",
	"./olympics/icons/left-arrow-red.png": "39d7",
	"./olympics/icons/right-arrow-red.png": "97cc",
	"./teams/Bundasliga-teams/Arminia-Bielefeld.png": "2ec0",
	"./teams/Bundasliga-teams/Augsburg.png": "aa0b",
	"./teams/Bundasliga-teams/Bayer-Leverkusen.png": "d0a6",
	"./teams/Bundasliga-teams/Bayern-Munchen.png": "b906",
	"./teams/Bundasliga-teams/Borussia-Dortmund.png": "7baf",
	"./teams/Bundasliga-teams/Borussia-M-gladbach.png": "74c7",
	"./teams/Bundasliga-teams/Eintracht-Frankfurt.png": "3248",
	"./teams/Bundasliga-teams/Freiburg.png": "8217",
	"./teams/Bundasliga-teams/Greuther-furth.png": "c2c3",
	"./teams/Bundasliga-teams/Hertha-BSC.png": "3108",
	"./teams/Bundasliga-teams/Hoffenheim.png": "96d2",
	"./teams/Bundasliga-teams/Koln.png": "1053",
	"./teams/Bundasliga-teams/Mainz-05.png": "deb5",
	"./teams/Bundasliga-teams/RB-Leipzig.png": "753c",
	"./teams/Bundasliga-teams/Schalke-04.png": "7273",
	"./teams/Bundasliga-teams/Stuttgart.png": "ebd8",
	"./teams/Bundasliga-teams/Union-Berlin.png": "5161",
	"./teams/Bundasliga-teams/Werder-Bremen.png": "17de",
	"./teams/Bundasliga-teams/Wolfsburg.png": "e7b6",
	"./teams/Bundasliga-teams/bochum.png": "7532",
	"./teams/Champions-League-Teams/Benfica.png": "51e6",
	"./teams/Champions-League-Teams/Brondby.png": "f8d8",
	"./teams/Champions-League-Teams/Dinamo-Zagreb.png": "b982",
	"./teams/Champions-League-Teams/Genk.png": "2edd",
	"./teams/Champions-League-Teams/HB-Torshavn.png": "da39",
	"./teams/Champions-League-Teams/Inter-Escaldes.png": "7e51",
	"./teams/Champions-League-Teams/Lille.png": "829f",
	"./teams/Champions-League-Teams/Monaco.png": "7a7c",
	"./teams/Champions-League-Teams/Olympiacos.png": "3931",
	"./teams/Champions-League-Teams/Prishtina.png": "02e4",
	"./teams/Champions-League-Teams/RB-Salzburg.png": "5f19",
	"./teams/Champions-League-Teams/SS-Folgore.png": "7019",
	"./teams/Champions-League-Teams/Shakhtar-Donetsk.png": "bf6f",
	"./teams/Champions-League-Teams/Slavia-Prague.png": "e66c",
	"./teams/Champions-League-Teams/Spartak-Moscow.png": "71d2",
	"./teams/Champions-League-Teams/Villarreal.png": "aaee",
	"./teams/Champions-League-Teams/Wolfsburg.png": "d3f0",
	"./teams/Champions-League-Teams/Young-Boys.png": "3c1e",
	"./teams/Champions-League-Teams/ajax-amsterdam.png": "dfb6",
	"./teams/Champions-League-Teams/alashkert.png": "6730",
	"./teams/Champions-League-Teams/atalanta-bc.png": "c1aa",
	"./teams/Champions-League-Teams/atletico-madrid.png": "0ac0",
	"./teams/Champions-League-Teams/az_alkmaar.png": "2ef5",
	"./teams/Champions-League-Teams/barcelona.png": "5b01",
	"./teams/Champions-League-Teams/bayern-munich.png": "66c6",
	"./teams/Champions-League-Teams/bodo-glimt.png": "91b5",
	"./teams/Champions-League-Teams/borac-banja-luka.png": "57f1",
	"./teams/Champions-League-Teams/borussia-monchengladbach.png": "b64a",
	"./teams/Champions-League-Teams/buducnost.png": "8736",
	"./teams/Champions-League-Teams/bvb-borussia-dortmund.png": "18ab",
	"./teams/Champions-League-Teams/celtic-fc.png": "9476",
	"./teams/Champions-League-Teams/cfr-cluj.png": "88e2",
	"./teams/Champions-League-Teams/chelsea-fc.png": "f233",
	"./teams/Champions-League-Teams/club-brugge-kv.png": "0ee2",
	"./teams/Champions-League-Teams/connah's-quay.png": "9fc5",
	"./teams/Champions-League-Teams/dinamo-tbilisi.png": "0ab2",
	"./teams/Champions-League-Teams/dundalk-fc.png": "f420",
	"./teams/Champions-League-Teams/fc-dinamo-tbilisi.png": "57c6",
	"./teams/Champions-League-Teams/fc-dynamo-kyiv.png": "8703",
	"./teams/Champions-League-Teams/fc-dynamo-rest.png": "bda0",
	"./teams/Champions-League-Teams/fc-flora.png": "3175",
	"./teams/Champions-League-Teams/fc-krasnodar.png": "e2fb",
	"./teams/Champions-League-Teams/fc-lokomotiv-moscow.png": "130f",
	"./teams/Champions-League-Teams/fc-midtjylland.png": "36b8",
	"./teams/Champions-League-Teams/fc-porto.png": "794c",
	"./teams/Champions-League-Teams/fc-red-bull-salzburg-fc.png": "1bde",
	"./teams/Champions-League-Teams/fc-seville.png": "19a0",
	"./teams/Champions-League-Teams/fc-zenit-saint-petersburg.png": "c7cb",
	"./teams/Champions-League-Teams/ferencva-türosi-clogo.png": "9c48",
	"./teams/Champions-League-Teams/fola-esch.png": "664f",
	"./teams/Champions-League-Teams/galatasaray.png": "b7f1",
	"./teams/Champions-League-Teams/generic-logo.png": "3be0",
	"./teams/Champions-League-Teams/hibernians.png": "f257",
	"./teams/Champions-League-Teams/hjk.png": "dd7a",
	"./teams/Champions-League-Teams/inter-milan.png": "7be2",
	"./teams/Champions-League-Teams/istanbul-basaksehir.png": "76ec",
	"./teams/Champions-League-Teams/juventus.png": "543f",
	"./teams/Champions-League-Teams/kaa-gent.png": "a05c",
	"./teams/Champions-League-Teams/kairat.png": "99bf",
	"./teams/Champions-League-Teams/legia-warszawa.png": "fe09",
	"./teams/Champions-League-Teams/lincoln-red.png": "aaee4",
	"./teams/Champions-League-Teams/linfield.png": "34fb",
	"./teams/Champions-League-Teams/liverpool.png": "d1af",
	"./teams/Champions-League-Teams/ludogorets.png": "e0ba",
	"./teams/Champions-League-Teams/maccabi-haifa.png": "6ded",
	"./teams/Champions-League-Teams/maccabi-tel-aviv-fc.png": "92c4",
	"./teams/Champions-League-Teams/malmo-ff.png": "304c",
	"./teams/Champions-League-Teams/manchester-city.png": "7c1c",
	"./teams/Champions-League-Teams/manchester-united.png": "1547",
	"./teams/Champions-League-Teams/marseilles-fc.png": "7aa4",
	"./teams/Champions-League-Teams/milan.png": "9cfd",
	"./teams/Champions-League-Teams/molde-fk.png": "2aed",
	"./teams/Champions-League-Teams/mura.png": "619d",
	"./teams/Champions-League-Teams/neftci.png": "900d",
	"./teams/Champions-League-Teams/olympiacos-fc.png": "0e48",
	"./teams/Champions-League-Teams/omonia.png": "c5f0",
	"./teams/Champions-League-Teams/paris-saint-germain.png": "a147",
	"./teams/Champions-League-Teams/pfc-ludogorets-razgrad.png": "2635",
	"./teams/Champions-League-Teams/poak-fc.png": "bf9b",
	"./teams/Champions-League-Teams/psv-eindhoven.png": "9262",
	"./teams/Champions-League-Teams/qarabag-fk.png": "8098",
	"./teams/Champions-League-Teams/rapid-vienne.png": "e8da",
	"./teams/Champions-League-Teams/rb-leipzig.png": "8b42",
	"./teams/Champions-League-Teams/real-madrid.png": "1988",
	"./teams/Champions-League-Teams/riga.png": "3b29",
	"./teams/Champions-League-Teams/shakhtar.png": "b428",
	"./teams/Champions-League-Teams/shakhtyor.png": "456b",
	"./teams/Champions-League-Teams/shamrock.png": "05241",
	"./teams/Champions-League-Teams/sheriff.png": "425e",
	"./teams/Champions-League-Teams/shkendija.png": "f25b",
	"./teams/Champions-League-Teams/sk-slavia-raha.png": "ec5f",
	"./teams/Champions-League-Teams/sl-benfica.png": "4cdb",
	"./teams/Champions-League-Teams/slovan.png": "9263",
	"./teams/Champions-League-Teams/sp-tre-fiori.png": "6400",
	"./teams/Champions-League-Teams/sparta-praha.png": "424d",
	"./teams/Champions-League-Teams/sporting-cp.png": "cc76",
	"./teams/Champions-League-Teams/ss-lazio.png": "f3c3",
	"./teams/Champions-League-Teams/stade-renei-fc.png": "4b38",
	"./teams/Champions-League-Teams/teuta.png": "5f78",
	"./teams/Champions-League-Teams/valur.png": "d3a0",
	"./teams/Champions-League-Teams/zalgiris.png": "d28a",
	"./teams/EPL-Teams/1200px-Hibernian_FC_logo.svg.png": "6df8",
	"./teams/EPL-Teams/1200px-St_Mirren_FC_logo.svg.png": "83fb",
	"./teams/EPL-Teams/Ross_County_FC.webp": "f1e7",
	"./teams/EPL-Teams/arsenal.png": "d053",
	"./teams/EPL-Teams/aston-villa.png": "a6fd",
	"./teams/EPL-Teams/birmingham-city.png": "0ce5",
	"./teams/EPL-Teams/bournemouth-fc.png": "4396",
	"./teams/EPL-Teams/bradford-city-fc.png": "7d19",
	"./teams/EPL-Teams/brentford-fc.png": "0e53",
	"./teams/EPL-Teams/brighton-hove-albion.png": "99b1",
	"./teams/EPL-Teams/burnley.png": "9123",
	"./teams/EPL-Teams/cardiff-city.png": "95c9",
	"./teams/EPL-Teams/celtic-fc.png": "aa6d",
	"./teams/EPL-Teams/chelsea.png": "cf92",
	"./teams/EPL-Teams/crystal-palace.png": "91f8",
	"./teams/EPL-Teams/dundee-united.png": "c6cb",
	"./teams/EPL-Teams/everton-fc.png": "3c60",
	"./teams/EPL-Teams/fc-blackburn-rovers.png": "01d9",
	"./teams/EPL-Teams/fulham-fc.png": "6bb4",
	"./teams/EPL-Teams/hamilton-academical-fc.png": "e51f",
	"./teams/EPL-Teams/harrogate-town.png": "f8b6",
	"./teams/EPL-Teams/huddersfield-town-afc.png": "aab9",
	"./teams/EPL-Teams/kilmarnock-logo-png-transparent.png": "1adb",
	"./teams/EPL-Teams/leeds-united.png": "9591",
	"./teams/EPL-Teams/leicester-city.png": "e772",
	"./teams/EPL-Teams/liverpool.png": "3389",
	"./teams/EPL-Teams/manchester-city.png": "bf1e",
	"./teams/EPL-Teams/manchester-united.png": "ac1e",
	"./teams/EPL-Teams/motherwell-fc.png": "8e83",
	"./teams/EPL-Teams/newcastle-united.png": "2575",
	"./teams/EPL-Teams/norwich.png": "a7e0",
	"./teams/EPL-Teams/reading-fc.png": "50e9",
	"./teams/EPL-Teams/sheffield-united.png": "4bb6",
	"./teams/EPL-Teams/southampton.png": "956e",
	"./teams/EPL-Teams/st-johnstone-fc.png": "e7af",
	"./teams/EPL-Teams/stoke-city.png": "fc36",
	"./teams/EPL-Teams/sunderland.png": "d6f1",
	"./teams/EPL-Teams/swansea-city-afc.png": "0737",
	"./teams/EPL-Teams/tottenham-hotspur.png": "93c5",
	"./teams/EPL-Teams/watford.png": "9895",
	"./teams/EPL-Teams/west-bromwich-albion.png": "dd66",
	"./teams/EPL-Teams/west-ham-united.png": "0d4f",
	"./teams/EPL-Teams/wolverhampton-wolves.png": "6cd4",
	"./teams/Euro-2020/Austria.png": "4377",
	"./teams/Euro-2020/Belgium.png": "84c5",
	"./teams/Euro-2020/Croatia.png": "4674",
	"./teams/Euro-2020/Czech-Republic.png": "08da",
	"./teams/Euro-2020/Denmark.png": "6067",
	"./teams/Euro-2020/England.png": "7bb1",
	"./teams/Euro-2020/Finland.png": "dc5f",
	"./teams/Euro-2020/France.png": "1708",
	"./teams/Euro-2020/Germany.png": "e3df",
	"./teams/Euro-2020/Hungary.png": "74e1",
	"./teams/Euro-2020/Italy.png": "f412",
	"./teams/Euro-2020/Netharlands.png": "4e64",
	"./teams/Euro-2020/Netherlands.png": "edc9",
	"./teams/Euro-2020/North-Macedonia.png": "d1d8",
	"./teams/Euro-2020/Poland.png": "b809",
	"./teams/Euro-2020/Portugal.png": "da9a",
	"./teams/Euro-2020/Russia.png": "3efb",
	"./teams/Euro-2020/Scotland.png": "2184",
	"./teams/Euro-2020/Slovakia.png": "326f",
	"./teams/Euro-2020/Spain.png": "5cc5",
	"./teams/Euro-2020/Sweden.png": "521c",
	"./teams/Euro-2020/Switzerland.png": "9848",
	"./teams/Euro-2020/Turkey.png": "10d0",
	"./teams/Euro-2020/Ukraine.png": "67dc",
	"./teams/Euro-2020/Wales.png": "02e1",
	"./teams/French-ligue-1/Angers-SCO.png": "1686",
	"./teams/French-ligue-1/Bordeaux.png": "1d24",
	"./teams/French-ligue-1/Brest.png": "307e",
	"./teams/French-ligue-1/Dijon.png": "d61b",
	"./teams/French-ligue-1/Lens.png": "b221",
	"./teams/French-ligue-1/Lille.png": "2b33",
	"./teams/French-ligue-1/Lorient.png": "b040",
	"./teams/French-ligue-1/Metz.png": "ebbe",
	"./teams/French-ligue-1/Monaco.png": "47a2",
	"./teams/French-ligue-1/Montpellier.png": "0b10",
	"./teams/French-ligue-1/Nantes.png": "c16f",
	"./teams/French-ligue-1/Nice.png": "3559",
	"./teams/French-ligue-1/Nimes.png": "685c",
	"./teams/French-ligue-1/Olympique-Lyonnais.png": "bead",
	"./teams/French-ligue-1/Olympique-Marseille.png": "3dd2",
	"./teams/French-ligue-1/PSG.png": "5c7d",
	"./teams/French-ligue-1/Reims.png": "02a6",
	"./teams/French-ligue-1/Rennes.png": "632c",
	"./teams/French-ligue-1/Saint-Etienne.png": "71d6",
	"./teams/French-ligue-1/Strasbourg.png": "16cd",
	"./teams/French-ligue-1/clermont.png": "bdb0",
	"./teams/French-ligue-1/troyes.png": "8df0",
	"./teams/Italian-serie-A/Cagliari.png": "8aab",
	"./teams/Italian-serie-A/atalanta.png": "9a5d",
	"./teams/Italian-serie-A/benevento.png": "a002",
	"./teams/Italian-serie-A/bologna.png": "372d",
	"./teams/Italian-serie-A/crotone.png": "7550",
	"./teams/Italian-serie-A/empoli.png": "d3d7",
	"./teams/Italian-serie-A/fiorentina.png": "1a2f",
	"./teams/Italian-serie-A/genoa.png": "482c",
	"./teams/Italian-serie-A/hellas-verona.png": "c975",
	"./teams/Italian-serie-A/internazionale.png": "2588",
	"./teams/Italian-serie-A/juventus-black.png": "74dd",
	"./teams/Italian-serie-A/juventus.png": "6a5e",
	"./teams/Italian-serie-A/lazio.png": "609b",
	"./teams/Italian-serie-A/milan.png": "84cf",
	"./teams/Italian-serie-A/napoli.png": "2137",
	"./teams/Italian-serie-A/parma.png": "1010",
	"./teams/Italian-serie-A/roma.png": "c917",
	"./teams/Italian-serie-A/salernitana.png": "084d",
	"./teams/Italian-serie-A/sampdoria.png": "188f",
	"./teams/Italian-serie-A/sassuolo.png": "90ff",
	"./teams/Italian-serie-A/spezia.png": "1178",
	"./teams/Italian-serie-A/torino.png": "63f1",
	"./teams/Italian-serie-A/udinese.png": "f337",
	"./teams/Italian-serie-A/venezia.png": "fbbf",
	"./teams/Olympics-2021/Abkhazia.png": "9120",
	"./teams/Olympics-2021/Afghanistan.png": "eeda",
	"./teams/Olympics-2021/Alaska.png": "6546",
	"./teams/Olympics-2021/Albania.png": "5632",
	"./teams/Olympics-2021/Algeria.png": "d5eb",
	"./teams/Olympics-2021/American-Samoa.png": "e622",
	"./teams/Olympics-2021/Andorra.png": "02fa",
	"./teams/Olympics-2021/Angola.png": "db75",
	"./teams/Olympics-2021/Anguilla.png": "7292",
	"./teams/Olympics-2021/Antartica.png": "fecb",
	"./teams/Olympics-2021/Antigua-&-Barbuda.png": "e29d",
	"./teams/Olympics-2021/Argentina.png": "d8c6",
	"./teams/Olympics-2021/Argentine-Antarctica.png": "139a",
	"./teams/Olympics-2021/Armenia.png": "d29a",
	"./teams/Olympics-2021/Aruba.png": "a226",
	"./teams/Olympics-2021/Asean.png": "0dda",
	"./teams/Olympics-2021/Australia.png": "f2f5",
	"./teams/Olympics-2021/Austria.png": "a930",
	"./teams/Olympics-2021/Azerbaijan.png": "179e",
	"./teams/Olympics-2021/Bahamas.png": "675d",
	"./teams/Olympics-2021/Bahrain.png": "5d94",
	"./teams/Olympics-2021/Bangladesh.png": "a089",
	"./teams/Olympics-2021/Barbados.png": "f8f5",
	"./teams/Olympics-2021/Belarus.png": "c868",
	"./teams/Olympics-2021/Belgium.png": "7775",
	"./teams/Olympics-2021/Belize.png": "5ef6",
	"./teams/Olympics-2021/Benin.png": "1a71",
	"./teams/Olympics-2021/Bermuda.png": "424d1",
	"./teams/Olympics-2021/Bhutan.png": "e718",
	"./teams/Olympics-2021/Bolivia.png": "ac5e",
	"./teams/Olympics-2021/Bosnia-&-Herzegovina.png": "689b",
	"./teams/Olympics-2021/Botswana.png": "4ad7",
	"./teams/Olympics-2021/Brazil.png": "3d1a",
	"./teams/Olympics-2021/British-Virgin-Islands.png": "97d7",
	"./teams/Olympics-2021/Brunei.png": "f543",
	"./teams/Olympics-2021/Bulgaria.png": "6c04",
	"./teams/Olympics-2021/Burkina-Faso.png": "ddc4",
	"./teams/Olympics-2021/Burundi.png": "63c2",
	"./teams/Olympics-2021/Cambodia.png": "e216",
	"./teams/Olympics-2021/Cameroon.png": "8bbb",
	"./teams/Olympics-2021/Canada.png": "1838",
	"./teams/Olympics-2021/Cape-Verde.png": "f7f1",
	"./teams/Olympics-2021/Catalonia.png": "3455",
	"./teams/Olympics-2021/Cayman-Islands.png": "e028",
	"./teams/Olympics-2021/Central-African-Repu.png": "de0e",
	"./teams/Olympics-2021/Chad.png": "1e57",
	"./teams/Olympics-2021/Chile.png": "d327",
	"./teams/Olympics-2021/Chilean-Antarctic-Te.png": "3855",
	"./teams/Olympics-2021/China.png": "352f",
	"./teams/Olympics-2021/Chinese-Taipei.png": "80db",
	"./teams/Olympics-2021/Christmas-Island.png": "a368",
	"./teams/Olympics-2021/Cocos-Islands.png": "596a",
	"./teams/Olympics-2021/Colombia.png": "888e",
	"./teams/Olympics-2021/Comoros.png": "baf4",
	"./teams/Olympics-2021/Cook-Islands.png": "4d9c",
	"./teams/Olympics-2021/Costa-Rica.png": "9dd0",
	"./teams/Olympics-2021/Cote D’ivoire.png": "9fe2",
	"./teams/Olympics-2021/Croatia.png": "b453",
	"./teams/Olympics-2021/Cuba.png": "b0a5",
	"./teams/Olympics-2021/Curacao.png": "6813",
	"./teams/Olympics-2021/Cyprus.png": "ca21",
	"./teams/Olympics-2021/Czechia.png": "6657",
	"./teams/Olympics-2021/DRC.png": "a75f",
	"./teams/Olympics-2021/Denmark.png": "0dfd",
	"./teams/Olympics-2021/Djibouti.png": "5272",
	"./teams/Olympics-2021/Dominica.png": "c1f0",
	"./teams/Olympics-2021/Dominican-Republic.png": "7eb0",
	"./teams/Olympics-2021/Ecuador.png": "3c4c",
	"./teams/Olympics-2021/Egypt.png": "e5d7",
	"./teams/Olympics-2021/El-Salvador.png": "afdf",
	"./teams/Olympics-2021/England.png": "130c",
	"./teams/Olympics-2021/Equatorial-Guinea.png": "319e",
	"./teams/Olympics-2021/Eritrea.png": "b3b5",
	"./teams/Olympics-2021/Estonia.png": "9801",
	"./teams/Olympics-2021/Ethiopia.png": "109d",
	"./teams/Olympics-2021/European-Union.png": "623a",
	"./teams/Olympics-2021/Faroe-Islands.png": "ea06",
	"./teams/Olympics-2021/Fiji.png": "a9ad",
	"./teams/Olympics-2021/Finland.png": "bbf3",
	"./teams/Olympics-2021/France.png": "2968",
	"./teams/Olympics-2021/French Guiana.png": "583b",
	"./teams/Olympics-2021/French-Guiana.png": "fa4e",
	"./teams/Olympics-2021/Gabon.png": "31cc",
	"./teams/Olympics-2021/Georgia.png": "f239",
	"./teams/Olympics-2021/Germany.png": "0e73",
	"./teams/Olympics-2021/Ghana.png": "09df",
	"./teams/Olympics-2021/Great-Britain.png": "2b8b",
	"./teams/Olympics-2021/Greece.png": "cd3c",
	"./teams/Olympics-2021/Greenland.png": "0d21",
	"./teams/Olympics-2021/Grenada.png": "ebd1",
	"./teams/Olympics-2021/Guadeloupe.png": "787f",
	"./teams/Olympics-2021/Guam.png": "a96f",
	"./teams/Olympics-2021/Guatemala.png": "4e2c",
	"./teams/Olympics-2021/Guernsey.png": "6b9c",
	"./teams/Olympics-2021/Guinea-Bissau.png": "002d",
	"./teams/Olympics-2021/Guinea.png": "c206",
	"./teams/Olympics-2021/Guyana.png": "99ba",
	"./teams/Olympics-2021/Haiti.png": "8d36",
	"./teams/Olympics-2021/Honduras.png": "8aac",
	"./teams/Olympics-2021/Hong-Kong.png": "7386c",
	"./teams/Olympics-2021/Hungary.png": "765d",
	"./teams/Olympics-2021/Iceland.png": "9c80",
	"./teams/Olympics-2021/India.png": "9489",
	"./teams/Olympics-2021/Indonesia.png": "def2",
	"./teams/Olympics-2021/Iran.png": "dd66e",
	"./teams/Olympics-2021/Iraq.png": "016d",
	"./teams/Olympics-2021/Iraqi-Kurdistan.png": "c1f8",
	"./teams/Olympics-2021/Ireland.png": "8b1b",
	"./teams/Olympics-2021/Isle-of-Man.png": "d87b",
	"./teams/Olympics-2021/Israel.png": "87fc",
	"./teams/Olympics-2021/Italy.png": "5d30",
	"./teams/Olympics-2021/Ivory-Coast.png": "3f7a",
	"./teams/Olympics-2021/Jamaica.png": "6012",
	"./teams/Olympics-2021/Japan.png": "aefd",
	"./teams/Olympics-2021/Jordan.png": "44e2",
	"./teams/Olympics-2021/Kazakhstan.png": "3564",
	"./teams/Olympics-2021/Kenya.png": "b4e4",
	"./teams/Olympics-2021/Kiribati.png": "b519",
	"./teams/Olympics-2021/Kosovo.png": "0d40",
	"./teams/Olympics-2021/Kuwait.png": "883b",
	"./teams/Olympics-2021/Kyrgyzstan.png": "1f27",
	"./teams/Olympics-2021/Lao-People's-Democratic-Republic.png": "30ed",
	"./teams/Olympics-2021/Latvia.png": "9aa6",
	"./teams/Olympics-2021/Lebanon.png": "0984",
	"./teams/Olympics-2021/Lesotho.png": "2bd4",
	"./teams/Olympics-2021/Liberia.png": "9be2",
	"./teams/Olympics-2021/Libya.png": "b90d",
	"./teams/Olympics-2021/Liechtenstein.png": "c7d9",
	"./teams/Olympics-2021/Lithuania.png": "26ad",
	"./teams/Olympics-2021/Luxembourg.png": "b827",
	"./teams/Olympics-2021/Macau.png": "9657",
	"./teams/Olympics-2021/Macedonia.png": "4c86",
	"./teams/Olympics-2021/Madagascar.png": "1ef4",
	"./teams/Olympics-2021/Madeira.png": "8a9b",
	"./teams/Olympics-2021/Malawi.png": "172c",
	"./teams/Olympics-2021/Malaysia.png": "2685",
	"./teams/Olympics-2021/Maldives.png": "389d",
	"./teams/Olympics-2021/Mali.png": "fe0f",
	"./teams/Olympics-2021/Malta.png": "8aab9",
	"./teams/Olympics-2021/Marshall-Islands.png": "f5e6",
	"./teams/Olympics-2021/Mauritania.png": "5ed8",
	"./teams/Olympics-2021/Mauritius.png": "05f3",
	"./teams/Olympics-2021/Mexico.png": "2803",
	"./teams/Olympics-2021/Micronesia.png": "7dab",
	"./teams/Olympics-2021/Moldova.png": "e5e4",
	"./teams/Olympics-2021/Monaco.png": "69a4",
	"./teams/Olympics-2021/Mongolia.png": "b125",
	"./teams/Olympics-2021/Montenegro.png": "fb82",
	"./teams/Olympics-2021/Morocco.png": "0a8e",
	"./teams/Olympics-2021/Mozambique.png": "7a4e",
	"./teams/Olympics-2021/Myanmar.png": "dbea",
	"./teams/Olympics-2021/Namibia.png": "5e10",
	"./teams/Olympics-2021/Nauru.png": "9d4d",
	"./teams/Olympics-2021/Nepal.png": "06f3",
	"./teams/Olympics-2021/Netherlands-Antilles.png": "2fe6",
	"./teams/Olympics-2021/Netherlands.png": "4ef8",
	"./teams/Olympics-2021/New-Caledonia.png": "6b07",
	"./teams/Olympics-2021/New-Zealand.png": "609a",
	"./teams/Olympics-2021/Nicaragua.png": "f4f7",
	"./teams/Olympics-2021/Niger.png": "1cd2",
	"./teams/Olympics-2021/Nigeria.png": "8aef",
	"./teams/Olympics-2021/Niue.png": "66dd",
	"./teams/Olympics-2021/Norfolk-Island.png": "c1ea",
	"./teams/Olympics-2021/North-Korea.png": "6b62",
	"./teams/Olympics-2021/North-Macedonia.png": "0ad7",
	"./teams/Olympics-2021/Northern-Cyprus.png": "3c63",
	"./teams/Olympics-2021/Norway.png": "b42b",
	"./teams/Olympics-2021/Oman.png": "553d",
	"./teams/Olympics-2021/Pakistan.png": "c471",
	"./teams/Olympics-2021/Palau.png": "5072",
	"./teams/Olympics-2021/Palestine.png": "b26f",
	"./teams/Olympics-2021/Panama.png": "2c1c",
	"./teams/Olympics-2021/Papua-New-Guinea.png": "3dbb",
	"./teams/Olympics-2021/Paraguay.png": "f92b",
	"./teams/Olympics-2021/Peru.png": "0f7e",
	"./teams/Olympics-2021/Philippines.png": "742a",
	"./teams/Olympics-2021/Poland.png": "7863",
	"./teams/Olympics-2021/Portugal.png": "a6aa",
	"./teams/Olympics-2021/Puerto-Rico.png": "5126",
	"./teams/Olympics-2021/Qatar.png": "f951",
	"./teams/Olympics-2021/Republic-of-Artsakh.png": "3ef0",
	"./teams/Olympics-2021/Republic-of-Congo.png": "87c4",
	"./teams/Olympics-2021/Romania.png": "a55f",
	"./teams/Olympics-2021/Russia.png": "e70e",
	"./teams/Olympics-2021/Rwanda.png": "f2f0",
	"./teams/Olympics-2021/Saint-Kitts-&-Nevis.png": "d530",
	"./teams/Olympics-2021/Saint-Lucia.png": "13d1",
	"./teams/Olympics-2021/Samoa.png": "f33a",
	"./teams/Olympics-2021/San-Marino.png": "25fe",
	"./teams/Olympics-2021/Sao-Tome-&-Principe.png": "f8af",
	"./teams/Olympics-2021/Saudi-Arabia.png": "aa1a",
	"./teams/Olympics-2021/Senegal.png": "941e",
	"./teams/Olympics-2021/Serbia.png": "33c0",
	"./teams/Olympics-2021/Seychelles.png": "89c6",
	"./teams/Olympics-2021/Sierra-Leone.png": "96d6",
	"./teams/Olympics-2021/Singapore.png": "27b5",
	"./teams/Olympics-2021/Slovakia.png": "580d",
	"./teams/Olympics-2021/Slovenia.png": "cd18",
	"./teams/Olympics-2021/Solomon-Islands.png": "6aa7",
	"./teams/Olympics-2021/Somalia.png": "9391",
	"./teams/Olympics-2021/Somaliland.png": "08d8",
	"./teams/Olympics-2021/South-Africa.png": "d46d",
	"./teams/Olympics-2021/South-Korea.png": "0a48",
	"./teams/Olympics-2021/South-Ossetia.png": "9541",
	"./teams/Olympics-2021/South-Sudan.png": "8534",
	"./teams/Olympics-2021/Spain.png": "fc4c",
	"./teams/Olympics-2021/Sri-Lanka.png": "d01f",
	"./teams/Olympics-2021/St-Vincent-and-Grandines.png": "a48b",
	"./teams/Olympics-2021/Sudan.png": "c3d8e",
	"./teams/Olympics-2021/Suriname.png": "d1cc",
	"./teams/Olympics-2021/Swaziland.png": "c080",
	"./teams/Olympics-2021/Sweden.png": "be42",
	"./teams/Olympics-2021/Switzerland.png": "ec71",
	"./teams/Olympics-2021/Syria.png": "da81",
	"./teams/Olympics-2021/Taiwan.png": "79cf",
	"./teams/Olympics-2021/Tajikistan.png": "e77b",
	"./teams/Olympics-2021/Tanzania.png": "90ab",
	"./teams/Olympics-2021/Thailand.png": "3fe5",
	"./teams/Olympics-2021/The-Gambia.png": "06d3",
	"./teams/Olympics-2021/Timor-Leste.png": "1a3f",
	"./teams/Olympics-2021/Togo.png": "dd60",
	"./teams/Olympics-2021/Tokelau.png": "0d86",
	"./teams/Olympics-2021/Tonga.png": "b4f0",
	"./teams/Olympics-2021/Transnistria.png": "ea6d",
	"./teams/Olympics-2021/Trinidad-&-Tabago.png": "eeb5",
	"./teams/Olympics-2021/Trinidad-&-Tobago.png": "387f",
	"./teams/Olympics-2021/Trinidad-and-Tobago.png": "554d",
	"./teams/Olympics-2021/Tunisia.png": "6389",
	"./teams/Olympics-2021/Turkey.png": "ec7a",
	"./teams/Olympics-2021/Turkmenistan.png": "d0b5",
	"./teams/Olympics-2021/Tuvalu.png": "6c2a",
	"./teams/Olympics-2021/UAE.png": "9dba",
	"./teams/Olympics-2021/USA.png": "bd8c",
	"./teams/Olympics-2021/Uganda.png": "19de",
	"./teams/Olympics-2021/Ukraine.png": "a2fb",
	"./teams/Olympics-2021/United-Kingdom.png": "b7fb",
	"./teams/Olympics-2021/Uruguay.png": "9549",
	"./teams/Olympics-2021/Uzbekistan.png": "0799",
	"./teams/Olympics-2021/Vanuatu.png": "7408",
	"./teams/Olympics-2021/Vatican-City-State.png": "b54d",
	"./teams/Olympics-2021/Venezuela.png": "d95f",
	"./teams/Olympics-2021/Vietnam.png": "04ca",
	"./teams/Olympics-2021/Virgin-Islands.png": "0258",
	"./teams/Olympics-2021/Wales.png": "295b",
	"./teams/Olympics-2021/Yemen.png": "4d51",
	"./teams/Olympics-2021/Zambia.png": "13f0",
	"./teams/Olympics-2021/Zimbabwe.png": "c86e",
	"./teams/PSL-Teams/Fix/Polokwane_City_FC_logo.png": "d01e",
	"./teams/PSL-Teams/Royal-am.png": "bdf8",
	"./teams/PSL-Teams/Sekhukhune-united.png": "82c9",
	"./teams/PSL-Teams/ajax-cape-town.png": "7325",
	"./teams/PSL-Teams/amazulu.png": "da398",
	"./teams/PSL-Teams/baroka-fc.png": "a56f",
	"./teams/PSL-Teams/black-leopards.png": "c51b",
	"./teams/PSL-Teams/bloemfontein-celtic-fc.png": "fe9f",
	"./teams/PSL-Teams/cape-town-city-reserves.png": "39e1",
	"./teams/PSL-Teams/cape-town-city.png": "33e2",
	"./teams/PSL-Teams/chippa-united-fc.png": "1f56",
	"./teams/PSL-Teams/golden-arrows-fc.png": "6840",
	"./teams/PSL-Teams/highlands-park-fc.png": "d8c8",
	"./teams/PSL-Teams/kaizer-chiefs.png": "5b3c",
	"./teams/PSL-Teams/mamelodi-sundowns.png": "f8e5",
	"./teams/PSL-Teams/maritzburg-united.png": "b460",
	"./teams/PSL-Teams/moroka-swallows.png": "ceec",
	"./teams/PSL-Teams/mpumalanga-black-aces.png": "e056",
	"./teams/PSL-Teams/orlando-pirates.png": "95fa",
	"./teams/PSL-Teams/polokwane-city.png": "c621",
	"./teams/PSL-Teams/santos.png": "2f4d",
	"./teams/PSL-Teams/stellenbosch-fc.png": "7bce",
	"./teams/PSL-Teams/supersport-united-fc.png": "de0b",
	"./teams/PSL-Teams/thanda-royal-zulu-fc.png": "b9b9",
	"./teams/PSL-Teams/ts-galaxy.png": "be49",
	"./teams/PSL-Teams/ttm.png": "5c80",
	"./teams/PSL-Teams/vasco-da-gama.png": "43ab",
	"./teams/Spanish-LaLiga/Athletic-club.png": "e77a",
	"./teams/Spanish-LaLiga/Atletico-Madrid.png": "1a42",
	"./teams/Spanish-LaLiga/Barcelona.png": "13f7",
	"./teams/Spanish-LaLiga/Cadiz.png": "cd1f",
	"./teams/Spanish-LaLiga/Celta-de-Vigo.png": "f762",
	"./teams/Spanish-LaLiga/Deportivo-Alaves.png": "c5ae",
	"./teams/Spanish-LaLiga/Eibar.png": "7c68",
	"./teams/Spanish-LaLiga/Elche.png": "0364",
	"./teams/Spanish-LaLiga/Getafe.png": "966e",
	"./teams/Spanish-LaLiga/Granada.png": "e277",
	"./teams/Spanish-LaLiga/Huesca.png": "5028",
	"./teams/Spanish-LaLiga/Levante.png": "0e49",
	"./teams/Spanish-LaLiga/Osasuna.png": "7c83",
	"./teams/Spanish-LaLiga/Real-Betis.png": "8392",
	"./teams/Spanish-LaLiga/Real-Madrid.png": "daa8",
	"./teams/Spanish-LaLiga/Real-Sociedad.png": "841e",
	"./teams/Spanish-LaLiga/Real-Valladolid.png": "f40f",
	"./teams/Spanish-LaLiga/Sevilla.png": "5b88",
	"./teams/Spanish-LaLiga/Valencia.png": "71d5",
	"./teams/Spanish-LaLiga/Villarreal.png": "1e5d",
	"./teams/Spanish-LaLiga/espanyol.png": "d9d8",
	"./teams/Spanish-LaLiga/mallorca.png": "2662",
	"./teams/Spanish-LaLiga/rayo-vallecano.png": "f985",
	"./teams/world-cup-t20-cricket/File-ScotlandMenCricketLogo.png": "992e3",
	"./teams/world-cup-t20-cricket/File_ScotlandMenCricketLogo.png": "1c9b",
	"./teams/world-cup-t20-cricket/afghanistan_icc.png": "5c31",
	"./teams/world-cup-t20-cricket/australia_icc.png": "24c1",
	"./teams/world-cup-t20-cricket/bangladesh_icc.png": "58ac",
	"./teams/world-cup-t20-cricket/england_icc.png": "040c",
	"./teams/world-cup-t20-cricket/ireland _icc.png": "4755",
	"./teams/world-cup-t20-cricket/namibia_icc.png": "2846",
	"./teams/world-cup-t20-cricket/netherlands_icc.png": "475a",
	"./teams/world-cup-t20-cricket/new_zealand_icc.png": "c349",
	"./teams/world-cup-t20-cricket/oman_icc.png": "1347",
	"./teams/world-cup-t20-cricket/pakistan_icc.png": "36ce",
	"./teams/world-cup-t20-cricket/papua_gew_guinea_icc.png": "f2be",
	"./teams/world-cup-t20-cricket/scotland_icc.png": "7d87",
	"./teams/world-cup-t20-cricket/south_africa_icc.png": "eb75",
	"./teams/world-cup-t20-cricket/sri_lanka_icc.png": "6a06",
	"./teams/world-cup-t20-cricket/west_indies_icc.png": "11e7",
	"./vodacom/Rings.png": "d0d3",
	"./vodacom/basketball-category-icon-red.png": "2052",
	"./vodacom/basketball-category-icon-white.png": "b49c",
	"./vodacom/basketball-icon-red.png": "18ed",
	"./vodacom/basketball-icon-white.png": "c7fb",
	"./vodacom/close-icon-white.svg": "a69a",
	"./vodacom/cricket-category-icon-red.png": "97f1",
	"./vodacom/cricket-category-icon-white.png": "1f97",
	"./vodacom/cricket-icon-red.png": "38e1",
	"./vodacom/cricket-icon-white.png": "5055",
	"./vodacom/down-arrow-white copy.png": "6783",
	"./vodacom/football-category-icon-red.png": "259f",
	"./vodacom/football-category-icon-white.png": "64ee",
	"./vodacom/football-icon-red.png": "4863",
	"./vodacom/generic-background-desktop.png": "24aa",
	"./vodacom/generic-background-mobile.png": "15ba",
	"./vodacom/home-manager-icon-red.png": "fae7",
	"./vodacom/home-manager-icon-white.png": "745c",
	"./vodacom/home-predict-icon-red.png": "8ce9",
	"./vodacom/home-predict-icon-white.png": "c3d8",
	"./vodacom/home-rugby-icon-red.png": "a300",
	"./vodacom/home-rugby-icon-white.png": "6a48",
	"./vodacom/home-soccer-icon-red.png": "45d9",
	"./vodacom/home-soccer-icon-white.png": "f2e2",
	"./vodacom/logo-200x200.png": "78bb",
	"./vodacom/logo-400x400.png": "b143",
	"./vodacom/menu-badge-icon-red.png": "5d7c",
	"./vodacom/menu-badge-icon-white.png": "3ba3",
	"./vodacom/menu-home-icon-red.png": "e537",
	"./vodacom/menu-home-icon-white.png": "ac0e",
	"./vodacom/menu-lock-icon-red.png": "8a66",
	"./vodacom/menu-lock-icon-white.png": "928c",
	"./vodacom/menu-predict-icon-red.png": "9b27",
	"./vodacom/menu-predict-icon-white.png": "09aa",
	"./vodacom/menu-question-mark-icon-red.png": "0cfd",
	"./vodacom/menu-question-mark-icon-white.png": "cba6",
	"./vodacom/menu-tandcs-icon-red.png": "41a4",
	"./vodacom/menu-tandcs-icon-white.png": "fc58",
	"./vodacom/menu-trophy-icon-red.png": "65f8",
	"./vodacom/menu-trophy-icon-white.png": "76d9",
	"./vodacom/minus-icon-grey.png": "6e6d",
	"./vodacom/minus-icon-red.png": "67d4",
	"./vodacom/minus-icon-white.png": "1f0f",
	"./vodacom/olympic-background-desktop.png": "7b55",
	"./vodacom/olympic-background-mobile.png": "c0cd",
	"./vodacom/olympics-icon-white.png": "b44e",
	"./vodacom/plus-icon-white.png": "6f5d",
	"./vodacom/pluss-icon-red.png": "0dbd",
	"./vodacom/right-arrow-red.png": "2f1f",
	"./vodacom/right-arrow-white.png": "af3b",
	"./vodacom/right-down-red.png": "c6bb",
	"./vodacom/rugby-category-icon-red.png": "992c",
	"./vodacom/rugby-category-icon-white.png": "946d",
	"./vodacom/rugby-icon-white.png": "2c6f",
	"./vodacom/soccer-background-desktop.png": "86bb",
	"./vodacom/soccer-background-mobile.png": "0cf2",
	"./vodacom/soccer-icon-white.png": "0524",
	"./vodacom/vodacom-basketball-background-desktop.png": "a433",
	"./vodacom/vodacom-basketball-background-mobile.png": "55a7",
	"./vodacom/vodacom-cricket-background-desktop.png": "585a",
	"./vodacom/vodacom-cricket-background-mobile.png": "a914",
	"./vodacom/vodacom-generic-background-desktop.png": "acec",
	"./vodacom/vodacom-generic-background-mobile.png": "9ae2",
	"./vodacom/vodacom-rugby-background-desktop.png": "f0ab",
	"./vodacom/vodacom-rugby-background-mobile.png": "d3d3"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "83cb";